import React from "react";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import CaretDownIcon from "../../SVGs/CaretDown";
import { DropdownContentLayout } from "./DropdownContentLayout";
import MenuItemDescription from "../NavMenuContents/MenuItemDescription";
import MenuItemList from "../NavMenuContents/MenuItemList";
import { useNavMenuHooks } from "../utils/useNavMenuHook";
import { AnimatePresence } from "framer-motion";
import { ResourcesMenuCategories } from "../NavData";
import {
  NavLinkClickHandler,
  NavMenuDropdownProps,
} from "src/assets/Types/Redesign/PrimaryNavMenuType.type";
import useMediaQueries from "@hooks/useMediaQueries";

const ResourcesMenu: React.FC<NavMenuDropdownProps & NavLinkClickHandler> = ({
  onClickHandler,
}) => {
  const { onMouseEnterHandler, isOpen, isShowDropdown } = useNavMenuHooks();

  const menuDescriptionProps = {
    title: "Resources",
    copy: "Whether you’re providing or seeking care, we offer helpful tools and tips. ",
    image: "/images/Resources.png",
    imageAltText: "some alt description",
  };

  const { isTouch } = useMediaQueries();

  return (
    <>
      <NavigationMenu.Trigger
        className="flex items-center justify-between group cursor-default bg-transparent px-0"
        onMouseEnter={onMouseEnterHandler}
        onClick={e => {
          if (!isTouch) {
            e.preventDefault();
          }
        }}
      >
        <p className="body--text-regular group-hover:font-semibold">
          Resources
        </p>
        <CaretDownIcon
          className="absolute right-0 transition-transform duration-[200] ease-in group-data-[state=open]:rotate-180"
          aria-hidden
        />
      </NavigationMenu.Trigger>
      {isShowDropdown && (
        <DropdownContentLayout className="gap-6 z-10">
          <AnimatePresence mode="wait" initial={false}>
            <MenuItemDescription {...menuDescriptionProps} isOpen={isOpen} />
            {ResourcesMenuCategories?.map((category, key) => (
              <MenuItemList
                key={key}
                category={category}
                isOpen={isOpen}
                onClickHandler={onClickHandler}
                title="resources"
              />
            ))}
          </AnimatePresence>
        </DropdownContentLayout>
      )}
    </>
  );
};

export default ResourcesMenu;
